module.exports = __webpack_public_path__ + "img/preset4.529b0d45.png";